import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export default function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className="flex items-start justify-between gap-6 border-b border-surface-border px-8 py-6 bg-surface">
      <div className="min-w-0">
        <h1 className="text-xl font-semibold text-slate-50 truncate">{title}</h1>
        {subtitle ? (
          <div className="mt-1 text-sm text-brand-dim">{subtitle}</div>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-3">{actions}</div> : null}
    </header>
  );
}
